import { API_BASE_URL } from "../config/api";
import {
  DEFAULT_NUMBER_FORMAT_SETTING,
  NumberFormatScale,
  NumberFormatSetting,
} from "../shared/utils/formatters";

const isValidScale = (value: unknown): value is NumberFormatScale => {
  return (
    value === "whole" ||
    value === "thousand" ||
    value === "lakh" ||
    value === "million" ||
    value === "crore" ||
    value === "billion"
  );
};

export async function getNumberFormatSetting(): Promise<NumberFormatSetting> {
  const url = `${API_BASE_URL}/api/settings/number-format`;
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error("Failed to fetch number format setting");
  }
  const body = await res.json();
  const raw = body?.data ?? body ?? {};

  return {
    scale: isValidScale(raw.scale)
      ? raw.scale
      : DEFAULT_NUMBER_FORMAT_SETTING.scale,
    decimals:
      typeof raw.decimals === "number"
        ? raw.decimals
        : DEFAULT_NUMBER_FORMAT_SETTING.decimals,
    suffix:
      typeof raw.suffix === "string"
        ? raw.suffix
        : DEFAULT_NUMBER_FORMAT_SETTING.suffix,
    currency:
      typeof raw.currency === "string"
        ? raw.currency
        : DEFAULT_NUMBER_FORMAT_SETTING.currency,
  };
}

export async function saveNumberFormatSetting(
  setting: NumberFormatSetting
): Promise<void> {
  const url = `${API_BASE_URL}/api/settings/number-format`;
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      scale: setting.scale,
      decimals: setting.decimals,
      suffix: setting.suffix ?? "",
      currency: setting.currency ?? "INR",
    }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const msg = body?.errors?.message ?? body?.message ?? "Failed to save number format setting";
    throw new Error(typeof msg === "string" ? msg : "Failed to save number format setting");
  }
}
